import { Directive, ElementRef, HostBinding, HostListener, Input, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { ContentService, DcrKeyPipe } from '@blk/cwp-ng-framework';
import { DzPopoverTrigger, TippyTooltipDirective } from '@blk/daisy/combinations/on-screen-help';
import { ITealiumAnalyticsOptions, TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { DebugQueryParamKey, SharedQueryParamKey } from '@ddt-web/url';
import { UntilDestroy } from '@ngneat/until-destroy';

import { TooltipPosition } from '../enums/tooltip-position.enum';

@UntilDestroy()
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[tooltip],[tooltip-dcr]'
})
export class TooltipDirective extends TippyTooltipDirective implements OnInit {
	@InjectQueryParam(SharedQueryParamKey.SHOW_TOOLTIP) private readonly showTooltipQp: boolean;
	@InjectQueryParam(DebugQueryParamKey.SHOW_EDITOR) private readonly showEditorQp: boolean;

	@Input('analytic-data') private analyticData: ITealiumAnalyticsOptions;
	@Input('tooltip') private templateRef: TemplateRef<any>;
	@Input('tooltip-dcr') private dcrKey: string;
	@Input('tooltip-position') public tooltipPosition: string = TooltipPosition.RIGHT;
	@Input('tooltip-hover') public tooltipHover: boolean = false;
	@Input('tooltip-always-show-icon') public showIcon: boolean = false;

	// Accessibility https://www.accede-web.com/en/guidelines/rich-interface-components/tooltips-aria/#ancre-08
	@HostBinding('attr.aria-describedby') private ariaDescribedBy: string = 'tooltipContent';

	constructor(
		private elementRefCurrent: ElementRef,
		viewContainer: ViewContainerRef,
		renderer: Renderer2,
		private contentService: ContentService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) {
		super(elementRefCurrent, viewContainer, renderer);
	}

	// THIS IS TEMPORARY. We need to move all HTML code to use <info-bubble>. Do not use this directive for new elements, use info-bubble
	public ngOnInit(): void {
		let tooltip;
		const options = {
			placement: this.tooltipPosition as any,
			trigger: this.tooltipHover ? DzPopoverTrigger.HOVER : DzPopoverTrigger.CLICK
		};

		if (this.dcrKey) {
			let dcrValue = this.contentService.get(this.dcrKey, '');
			if (this.showTooltipQp || this.showEditorQp) {
				dcrValue = `${new DcrKeyPipe().transform(this.dcrKey)}: ${dcrValue}`;
			}
			tooltip = dcrValue;

			if (!dcrValue.trim() && !this.showIcon) {
				this.elementRefCurrent.nativeElement.style.display = 'none';
			}
		} else if (this.templateRef) {
			tooltip = this.templateRef;
		}

		if (tooltip) {
			super.init(tooltip, options);
		}
	}

	@HostListener('click')
	public trackEvent(): void {
		if (this.analyticData) {
			const event = new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.TOOL_TIP, this.analyticData);
			this.tealiumAnalyticsService.trackEventTealium(event);
		} else if (this.dcrKey) {
			const linkName = this.dcrKey.replace('_TOOLTIP_TOOLTIP', '_TOOLTIP');
			const event = new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.TOOL_TIP, { linkName });
			this.tealiumAnalyticsService.trackEventTealium(event);
		}
	}

}
